import React, { useState, useRef } from "react";
import ReactSelect, { components } from "react-select";

const MultiSelect = (props) => {
  const [selectInput, setSelectInput] = useState("");
  const isAllSelected = useRef(false);
  const selectAllLabel = useRef("Select all");
  const allOption = { value: "*", label: selectAllLabel.current };

  const filterOptions = (options, input) =>
    options?.filter(({ label }) => {
      const labelText = typeof label === "string" ? label : String(label);
      return labelText?.toLowerCase().includes(input?.toLowerCase());
    });
  
 
  
  const comparator = (v1, v2) => v1.value - v2.value;

  let filteredOptions = filterOptions(props.options, selectInput);
  let filteredSelectedOptions = filterOptions(props.value, selectInput);

  const Option = (props) => (
    <components.Option {...props}>
      <div
        style={{ display: "flex", flexDirection: "row", whiteSpace: "nowrap" }}
      >
        {props.value === "*" &&
        !isAllSelected.current &&
        filteredSelectedOptions?.length > 0 ? (
          <input
            key={props.value}
            type="checkbox"
            ref={(input) => {
              if (input) input.indeterminate = true;
            }}
          />
        ) : (
          <input
            key={props.value}
            type="checkbox"
            checked={props.isSelected || isAllSelected.current}
            onChange={() => {}}
          />
        )}
        <label style={{ marginLeft: "5px", marginTop: "7px" }}>
          {props.label}
        </label>
      </div>
    </components.Option>
  );
  const customFilterOption = ({ value, label }, input) => {
    const labelText = typeof label === "string" ? label : String(label);
    return (
      (value !== "*" && labelText?.toLowerCase().includes(input?.toLowerCase())) ||
      (value === "*" && filteredOptions?.length > 0)
    );
  };
  const Input = (props) => (
    <>
      {selectInput.length === 0 ? (
        <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
          {props.children}
        </components.Input>
      ) : (
        <div style={{ border: "1px dotted gray" }}>
          <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
            {props.children}
          </components.Input>
        </div>
      )}
    </>
  );



  const onInputChange = (inputValue, action) => {
    if (action.action === "input-change") {
      setSelectInput(inputValue);
    } else if (action.action === "menu-close") {
      setSelectInput(""); 
    }
  };
  

  const onKeyDown = (e) => {
    if ((e.key === " " || e.key === "Enter") && !selectInput)
      e.preventDefault();
  };

  const handleChange = (selected) => {
    const areArraysEqual = (arr1, arr2) => {
      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
      if (arr1.length !== arr2.length) return false;
      return arr1.every((item, index) => item.value === arr2[index].value);
    };
  
    const comparator = (v1, v2) => v1.value - v2.value;
  
    const normalizeLabel = (label) => (typeof label === "string" ? label.toLowerCase() : "");
  
    const options = Array.isArray(props.options)
      ? props.options.map((opt) => ({
          ...opt,
          label: opt.label || "",
        }))
      : [];
  
    const value = Array.isArray(props.value)
      ? props.value.map((val) => ({
          ...val,
          label: val.label || "",
        }))
      : [];
  
    if (
      selected.length > 0 &&
      !isAllSelected.current &&
      (selected[selected.length - 1].value === allOption.value ||
        areArraysEqual(filteredOptions, selected.sort(comparator)))
    ) {
      props.onChange(
        [
          ...(value ?? []),
          ...options.filter(
            ({ label }) =>
              normalizeLabel(label).includes(selectInput?.toLowerCase()) &&
              (value ?? []).filter((opt) => normalizeLabel(opt.label) === normalizeLabel(label)).length === 0
          ),
        ].sort(comparator)
      );
    } else if (
      selected.length > 0 &&
      selected[selected.length - 1].value !== allOption.value &&
      !areArraysEqual(filteredOptions, selected.sort(comparator))
    ) {
      props.onChange(selected);
    } else {
      props.onChange([
        ...(value?.filter(
          ({ label }) => !normalizeLabel(label).includes(selectInput?.toLowerCase())
        )),
      ]);
    }
  };

  
  
  
  

  const customStyles = {
    multiValueLabel: (def) => ({
      ...def,
      backgroundColor: "lightgray",
    }),
    multiValueRemove: (def) => ({
      ...def,
      backgroundColor: "lightgray",
    }),
    valueContainer: (base) => ({
      ...base,
      maxHeight: "50px",
      overflow: "auto",
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      display: "flex", // Ensure flex layout for icons, avatars, and text
      alignItems: "center", // Vertically center elements
      padding: "2px 4px", // Reduce padding for more compact options
      fontSize: "10px", // Smaller font size
      lineHeight: "1.2", // Reduce line spacing
      minHeight: "18px", // Reduce the minimum height for options
      backgroundColor:
        isSelected && !isFocused
          ? null
          : isFocused && !isSelected
          ? styles.backgroundColor
          : isFocused && isSelected
          ? "#DEEBFF"
          : null,
      color: isSelected ? null : null,
    }),
    menu: (def) => ({ ...def, zIndex: 9999 }),
  };
  
  
  

  const areArraysEqual = (arr1, arr2) => {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false; // Defensive check for arrays
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => item.value === arr2[index].value);
  };
  
  if (props.isSelectAll && props.options.length !== 0) {
    let filteredOptions = filterOptions(props.options, selectInput) || [];
    let filteredSelectedOptions = filterOptions(props.value, selectInput) || [];
  
    isAllSelected.current = areArraysEqual(filteredSelectedOptions, filteredOptions);
  
    if (filteredSelectedOptions?.length > 0) {
      if (filteredSelectedOptions?.length === filteredOptions?.length)
        selectAllLabel.current = `All (${filteredOptions.length}) selected`;
      else
        selectAllLabel.current = `${filteredSelectedOptions?.length} / ${filteredOptions.length} selected`;
    } else {
      selectAllLabel.current = "Select all";
    }
  
    allOption.label = selectAllLabel.current;
  
    return (
      <ReactSelect
        {...props}
        inputValue={selectInput}
        onInputChange={onInputChange}
        onKeyDown={onKeyDown}
        options={[allOption, ...props.options]}
        onChange={handleChange}
        components={{
          Option: Option,
          Input: Input,
          ...props.components,
        }}
        filterOption={customFilterOption}
        menuPlacement={props.menuPlacement ?? "auto"}
        styles={customStyles}
        isMulti
        closeMenuOnSelect={false}
        tabSelectsValue={false}
        backspaceRemovesValue={false}
        hideSelectedOptions={false}
        blurInputOnSelect={false}
      />
    );
  }
  
  
};

export default MultiSelect;
